/* content file: replace all html between <> </> with actual content */

export const AwardGuteverwaltung = () => { 
  return (
  <>
    <p>
      Der Preis für gute Verwaltung richtet sich an ausgezeichnete Projekte, die einen Beitrag zu mehr Nutzer:innenfreundlichkeit in der Verwaltung anstreben.  GA-Lotse erhielt diese Auszeichnung im Rahmen der Public Service Lab Konferenz in Wiesbaden.</p>
  </>    
  )
}